import { useLocation } from 'react-router-dom'

export default function useLocationSearch() {
  const query: any = new URLSearchParams(useLocation().search)
  let params: { [key: string]: any } = {}
  for (var pair of query.entries()) {
    params[pair[0]] = pair[1]
  }

  return params
}
